<template>
  <RouterView />
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'App',
  data() {
    return {
      message: ''
    }
  }
})
</script>

<style>
/* Base Font Settings */
:root {
  --font-family-base: 'Open Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Helvetica Neue', sans-serif;
  --font-family-headings: 'Open Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, sans-serif;
  --font-size-base: 16px;
  --line-height-base: 1.5;
  --font-weight-normal: 400;
  --font-weight-medium: 500;
  --font-weight-bold: 600;


  /* Font sizing */
  --font-size-xs: 0.75rem;   /* 12px */
  --font-size-sm: 0.875rem;  /* 14px */
  --font-size-normal: 1rem;    /* 16px */
  --font-size-md: 1.125rem;  /* 18px */
  --font-size-lg: 1.25rem;   /* 20px */
  --font-size-xl: 1.5rem;    /* 24px */
  --font-size-2xl: 1.875rem; /* 30px */
  --font-size-3xl: 2.25rem;  /* 36px */
  --font-size-4xl: 3rem;     /* 48px */

  /* Color variables */
  --text-color-primary: #333333;
  --text-color-secondary: #666666;
  --text-color-muted: #888888;
  --text-color-light: #ffffff;

  --green-base: #196F58;
  --red-base: #BC3F23;
  --blue-base: #3C569B;
  --black-base: #171A19;
  --green-disabled: #AECAC3;
  --green-light-20: #196F5833;
  --green-light-10: #196F581A;

  --btn-default-radius:20px;

}

/* Global Typography */
body {
  font-family: var(--font-family-base);
  font-size: var(--font-size-base);
  line-height: var(--line-height-base);
  color: var(--text-color-primary);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

body {
  background-color: #ececec;
}

input, textarea, select {
  width: 100%;
  box-sizing: border-box;
}

.delete-btn {
  background-color: var(--red-base, #c00);
  color: #fff;
  border: none;
  border-radius: 4px;
  padding: 5px 10px;
  font-size: 0.9rem;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.delete-btn:hover {
  background-color: #a00;
}
</style>
